import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ReceiveTransferForm";
import {GET_STOCK_TRANSFER} from "../../../queries/stockTransfers";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelReceiveStockTransfer, successReceiveStockTransfer} from "../../../actions/StockTransferApiActions";
import {fromJS, List, Map} from "immutable";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class ReceiveTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = {
      transferId: this.props.transferId,
      lines: values.get("receivedLines", List()).toJS(),
    };

    return this.props.receiveStockTransfer(data)
      .then((response) => {
        if (response.data.receiveStockTransfer.errors.length <= 0) {
          this.props.successReceiveStockTransfer();
        } else {
          let errors = createValidationErrors(response.data.receiveStockTransfer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelReceiveStockTransfer();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    if (!data.stockTransfer) return <GraphQLErrors error={{message: "Transfer not found"}} />

    const lines = fromJS(data.stockTransfer.lines || []);
    const initialValues = Map({
      receivedLines: lines.map((line) => Map({
        lineId: line.get("id"),
        receivedQuantity: line.get("quantity"),
      }))
    });

    return (
      <Form
        lines={lines}
        initialValues={initialValues}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const RECEIVE_STOCK_TRANSFER = gql`
  mutation receiveStockTransfer($data: ReceiveStockTransferInput!) {
    receiveStockTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_STOCK_TRANSFER, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        id: props.transferId
      }
    })
  }),
  graphql(RECEIVE_STOCK_TRANSFER, {
    props: ({ mutate }) => ({
      receiveStockTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
);

export default connect(null, {cancelReceiveStockTransfer, successReceiveStockTransfer})(withQueries(ReceiveTransferFormContainer));
